interface RelativeUnit {
  unit: Intl.RelativeTimeFormatUnit;
  seconds: number;
}

const UNITS: RelativeUnit[] = [
  { unit: "year", seconds: 31536000 },
  { unit: "month", seconds: 2592000 },
  { unit: "day", seconds: 86400 },
  { unit: "hour", seconds: 3600 },
  { unit: "minute", seconds: 60 },
];

const formatter = new Intl.RelativeTimeFormat("en-US", { numeric: "auto" });

// "6 minutes ago", "2 hours ago", "yesterday" — from an ISO8601 timestamp.
const timeAgo = (isoTime: string): string => {
  const elapsed = (new Date(isoTime).getTime() - Date.now()) / 1000;
  const match = UNITS.find(({ seconds }) => Math.abs(elapsed) >= seconds) ?? { unit: "second", seconds: 1 };
  return formatter.format(Math.round(elapsed / match.seconds), match.unit);
};

export default timeAgo;
